import { Button, Flex } from 'antd'
import React from 'react'
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const NavBarLoggedIn = () => {
    const navigate = useNavigate();
    const logOut = () => {
        Cookies.remove('token'); // Remove the token from the cookies
        navigate('/login'); // Navigate to the login page
    }
  return (
    <Flex style={{padding: '2rem'}} justify='space-between'>
        <img src='https://thummimng.com/wp-content/uploads/2022/08/logo-full_fyjwy0-1.png' className='logo' alt='logo' />
        <Button onClick={logOut}>Logout</Button>
    </Flex>
  )
}

export default NavBarLoggedIn